import { apiClient, getToken, getOrgId } from '@devd-client/api';

export const updateContributorNameAndJobRole = (params: any): Promise<any> =>
  apiClient(`/v1/org/${getOrgId()}/employee/${params.email}/jobRole`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({
      firstName: params.firstName,
      lastName: params.lastName,
      jobRole: params.jobRole,
    }),
  });

export const getJobRoleNames = (): Promise<any> =>
  apiClient(`/v1/job-roles/org/${getOrgId()}/job-role-names`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
  });
